import { Box, useMediaQuery, useTheme } from '@mui/material';
import React from 'react'
import { MenuMenuCategoryCard } from './MenuCategoryCard';
import { IStoreState, useAppDispatch, useAppSelector } from '../../../../redux';
import { OutlinedTextField } from '../../../../Components/formComponents';
import { ICategory, fetchCategoriesListAsync, selectSingleCategorySync } from '../../../../redux/inventory';
import { useOutletContext } from '../../../../providers';


export const MenuCategoryList = () => {
    const { outlet_details: { outlet_uuid } } = useOutletContext()
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const {
        data: pos_categories_list,
    } = useAppSelector((storeState: IStoreState) => storeState.inventory.categories.category_list);
    const selectedCategory = useAppSelector((storeState: IStoreState) => storeState.inventory.categories.selected_category);

    const [searchText, setSearchText] = React.useState("")
    const [categoryList, setCategoryList] = React.useState<ICategory[]>([])

    React.useEffect(() => {
        if (!outlet_uuid) return
        dispatch(fetchCategoriesListAsync(outlet_uuid))
    }, [outlet_uuid])

    React.useEffect(() => {
        setCategoryList(pos_categories_list)
    }, [pos_categories_list])


    React.useEffect(() => {
        if (searchText.length > 0) {
            const newList = pos_categories_list.filter((item) => item.category_name.toLowerCase().includes(searchText.toLowerCase()))
            setCategoryList(newList)
        } else (
            setCategoryList(pos_categories_list)
        )
    }, [searchText, pos_categories_list])


    const handleCategorySelect = (category: ICategory) => {
        dispatch(selectSingleCategorySync(selectedCategory === category.category_uuid ? null : category.category_uuid))
    }

    return (
        <>
            <OutlinedTextField
                label="Search Category"
                id="account_name"
                value={searchText}
                onChange={(evt) => setSearchText(evt.target.value)}
            />

            <Box
                sx={{
                    height: isMobile ? "auto" : "77vh",
                    display: "flex",
                    flexDirection: isMobile ? "row" : "column",
                    gap: isMobile ? 0 : 1,
                    overflowY: isMobile ? "hidden" : "auto",
                    overflowX: isMobile ? "auto" : "hidden",
                    pr: 1,
                    mt: 1,
                    pb: isMobile ? 1 : 0,
                    // Enable smooth horizontal scrolling on mobile
                    scrollBehavior: "smooth",
                    // Hide scrollbar on mobile for cleaner look (optional)
                    "&::-webkit-scrollbar": {
                        height: isMobile ? "4px" : "auto",
                    },
                    "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "rgba(0,0,0,0.2)",
                        borderRadius: "2px",
                    },
                }}
            >

                {categoryList.map((item, index) => {
                    return (
                        <MenuMenuCategoryCard
                            key={index}
                            data={item}
                            isActive={item.category_uuid === selectedCategory}
                            onClick={() => handleCategorySelect(item)}
                        />
                    );
                })}
            </Box>
        </>

    )
}